import React from 'react';
import { useState, useRef, useEffect } from "react"
import { Sidebar } from "./SideBar"
import { TopBar } from "./TopBar"
import { AccountDropdown } from "./AccountDropdown"

interface LayoutProps {
    children: React.ReactNode
    activeMenuItem: string
}

export function Layout({ children, activeMenuItem }: LayoutProps) {
    const [isAccountDropdownOpen, setIsAccountDropdownOpen] = useState(false)
    const dropdownRef = useRef<HTMLDivElement>(null)
    const accountButtonRef = useRef<HTMLButtonElement>(null)

    const toggleAccountDropdown = () => {
        setIsAccountDropdownOpen(!isAccountDropdownOpen)
    }

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target as Node) &&
                accountButtonRef.current &&
                !accountButtonRef.current.contains(event.target as Node)
            ) {
                setIsAccountDropdownOpen(false)
            }
        }

        if (isAccountDropdownOpen) {
            document.addEventListener("mousedown", handleClickOutside)
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside)
        }
    }, [isAccountDropdownOpen])

    return (
        <div className="flex h-screen bg-background">
            <Sidebar activeMenuItem={activeMenuItem} />
            <div className="flex flex-col flex-1 overflow-hidden">
                <TopBar onAccountClick={toggleAccountDropdown} accountButtonRef={accountButtonRef} />
                {isAccountDropdownOpen && (
                    <div className="absolute right-4 top-16 z-50" ref={dropdownRef}>
                        <AccountDropdown />
                    </div>
                )}
                <main className="flex-1 overflow-auto p-6">{children}</main>
            </div>
        </div>
    )
}
